module.exports = __webpack_public_path__ + "static/media/FiraSans-Regular.54dfa44c.ttf";